import { AxiosError, HttpStatusCode } from 'axios';

import { RestClient } from '../../common/RestClient';
import { ProfessionalInfoResponse } from './types';

export class ProfessionalProfileService extends RestClient {
  constructor() {
    super();
  }
  execute = async (): Promise<ProfessionalInfoResponse> => {
    try {
      const { data } = await this.get('/lacreisaude/professional/');

      const profissionalInfo = {
        fullName: data.full_name,
        profileStatus: data.profile_status,
        profilePublished: data.published,
        profileActive: data.active,
        about: data.about_me,
        boardRegistrationNumber: data.board_registration_number,
        boardCertificationSelfie: data.board_certification_selfie,
        photo: data.photo,
        photoDescription: data.photo_description,
        documentNumber: data.document_number,
        specialty: data.specialty,
        genderIdentity: data.gender_identity,
        ethnicGroup: data.ethnic_group,
        pronoun: data.pronoun,
        sexuality: data.sexuality,
        disabilityTypes: data.disability_types,
        specialtyNumberRqe: data.specialty_number_rqe,
        verificationSteps: {
          currentStep: data.verification_steps.current_step,
          data: {
            isCompleted: data.verification_steps.data.is_completed,
            isSubmitted: data.verification_steps.data.is_submitted,
            description: data.verification_steps.data.description,
          },
        },
      };

      return profissionalInfo;
    } catch (error) {
      if (error instanceof AxiosError) {
        switch (error.response?.status) {
          case HttpStatusCode.Unauthorized:
            throw new Error('Usuário não autorizado.');
          case HttpStatusCode.NotFound:
            throw new Error('Perfil não encontrado.');
          case HttpStatusCode.InternalServerError:
            throw new Error('Erro interno no servidor.');
        }
      }
      throw new Error('Erro inesperado ao carregar dados.');
    }
  };
}
